import React, {useState} from "react";
import {RiDeleteBin7Line, RiEditLine, RiEyeLine} from 'react-icons/ri'
import Modal from "./Modal";
import DeleteModal from "./DeleteModal";
import {Link} from "react-router-dom";
import PreviewModal from "./PreviewModal";
import FormPreview from "./FormPreview";
import {RxEyeClosed} from "react-icons/rx";

const TableActions = ({deleteAction, updateForm, updateTitle, deleteText}) => {

    const [toggleDeleteModal, setToggleDeleteModal] = useState(false)
    const [toggleUpdateModal, setToggleUpdateModal] = useState(false)
    const handleDeleteModalToggle = () => {
        setToggleDeleteModal(prevState => !prevState);
    }

    const handleUpdateModalToggle = () => {
        setToggleUpdateModal(prevState => !prevState);
    }


    return (
        <div className="w-24 grid grid-cols-2 divide-x border rounded text-gray-500">
            <button type='button' onClick={handleUpdateModalToggle}
                    className='flex items-center justify-center py-2 hover:bg-blue-500 hover:text-white'><RiEditLine/>
            </button>
            <button type='button' onClick={handleDeleteModalToggle}
                    className='flex items-center justify-center py-2 hover:bg-red-500 hover:text-white'>
                <RiDeleteBin7Line/></button>
            <DeleteModal deleteText={deleteText} toggleModal={toggleDeleteModal} handleToggle={handleDeleteModalToggle}
                         deleteAction={deleteAction}/>
            <Modal title={updateTitle?.length > 0 ? updateTitle : 'Update it'} form={updateForm}
                   toggleModal={toggleUpdateModal} handleToggle={handleUpdateModalToggle}/>
        </div>
    );
};

export default TableActions;


export const ViewAction = ({id, name, deleteAction, deleteText}) => {
    const [togglePreviewModal, setTogglePreviewModal] = useState(false)
    const [toggleDeleteModal, setToggleDeleteModal] = useState(false)

    const handlePreviewModalToggle = () => {
        setTogglePreviewModal(prevState => !prevState);
    }

    const handleDeleteModalToggle = () => {
        setToggleDeleteModal(prevState => !prevState);
    }

    return (
        <div className="w-32 grid grid-cols-3 divide-x border rounded text-gray-500">
            <button type='button' onClick={handlePreviewModalToggle}
                    className='flex items-center justify-center py-2 hover:bg-green-500 hover:text-white'><RiEyeLine/>
            </button>
            <Link to={`${id}`}
                  className='flex items-center justify-center py-2 hover:bg-blue-500 hover:text-white'><RiEditLine/></Link>
            <button type='button' onClick={handleDeleteModalToggle}
                    className='flex items-center justify-center py-2 hover:bg-red-500 hover:text-white'>
                <RiDeleteBin7Line/></button>
            <DeleteModal deleteText={deleteText} toggleModal={toggleDeleteModal} handleToggle={handleDeleteModalToggle}
                         deleteAction={deleteAction}/>
            <PreviewModal toggleModal={togglePreviewModal} title={name} preview={<FormPreview formId={id}/>}
                          handleToggle={handlePreviewModalToggle}/>

        </div>
    );
}

export const ViewCommentAction = ({id, name, deleteAction, deleteText}) => {
    const [togglePreviewModal, setTogglePreviewModal] = useState(false)
    const [toggleDeleteModal, setToggleDeleteModal] = useState(false)

    const handlePreviewModalToggle = () => {
        setTogglePreviewModal(prevState => !prevState);
    }

    const handleDeleteModalToggle = () => {
        setToggleDeleteModal(prevState => !prevState);
    }

    return (

        <div className="w-32 grid grid-cols-2 divide-x border rounded text-gray-500">

            <Link to={`${id}`}
                  className='flex items-center justify-center py-2 hover:bg-blue-500 hover:text-white'><RiEditLine/></Link>
            <button type='button' onClick={handleDeleteModalToggle}
                    className='flex items-center justify-center py-2 hover:bg-red-500 hover:text-white'>
                <RiDeleteBin7Line/></button>
            <DeleteModal deleteText={deleteText} toggleModal={toggleDeleteModal} handleToggle={handleDeleteModalToggle}
                         deleteAction={deleteAction}/>
            <PreviewModal toggleModal={togglePreviewModal} title={name} preview={<FormPreview formId={id}/>}
                          handleToggle={handlePreviewModalToggle}/>

        </div>
    );
}


export const OnlyView = ({id, status = false,_officerId,history=false}) => {
    const {officerId} = JSON.parse(localStorage.getItem('user'))
   
    if (status && officerId!=_officerId) {
        return (
            <div
                className="w-12 border rounded text-gray-500 flex items-center justify-center py-2">
                <RxEyeClosed/>
            </div>
        );
    }
     if(history==true){
        return(
           <Link
            to={{pathname: `/historyForm/${id}`}}
            className="w-12 border rounded text-gray-500 flex items-center justify-center py-2 hover:bg-green-500 hover:text-white">
            <RiEyeLine/>
        </Link>
        )
     }
    return (
        <Link
            to={{pathname: `/deskForm/${id}`}}
            className="w-12 border rounded text-gray-500 flex items-center justify-center py-2 hover:bg-green-500 hover:text-white">
            <RiEyeLine/>
        </Link>

    );
}